export default {
	PERRITO: 'perrito',
	USER_SESSION: 'user-session',
	USER_ID: (userId: number) => `user_${userId}`,
	CLIENT_ID: (clientId: number) => `client.${clientId}`,
	MAINTENANCE_DASHBOARD: (clientId: number) => `maintenance-dashboard.${clientId}`,
	MAINTENANCE_ACCUMULATE: (clientId: number) => `maintenance-accumulate.${clientId}`,
	MAINTENANCE_DEVICE: (maintenanceId: number, deviceId: number) => `${maintenanceId}-${deviceId}`,
};
